// @flow

import { isArray } from 'lodash';

import getKeys from '@zapier/common-utils/src/getKeys';

import type { Keys } from '@zapier/common-utils/src/types';

const get = (thing: Function | ?{}, keys: Keys, defaultValue: mixed): any => {
  let context = null;
  let keyIndex = 0;

  const keysArray = getKeys(keys);

  while (keyIndex < keysArray.length && thing != null) {
    const key = keysArray[keyIndex];
    if (isArray(key)) {
      if (typeof thing === 'function') {
        thing = thing.apply(context, key);
        context = null;
      } else {
        thing = undefined;
      }
    } else if (thing != null) {
      context = thing;
      thing = thing[key];
    }
    keyIndex++;
  }

  if (thing == null && defaultValue != null) {
    return defaultValue;
  }

  return thing;
};

export default get;
